module.exports = __webpack_public_path__ + "static/media/lbc.900dfc2b.svg";